import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import { AreaBoundary } from './AreaBoundary.js';
import '@meu-mapa-nev/design-system/styles';

const RelatorioDeDados = React.lazy(() =>
  import('./privacidade/RelatorioDeDados.js').then((module) => ({
    default: module.RelatorioDeDados,
  })),
);

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      {window.location.pathname === '/relatorio' ? (
        <AreaBoundary>
          <React.Suspense fallback={<p role="status">Carregando relatório…</p>}>
            <RelatorioDeDados />
          </React.Suspense>
        </AreaBoundary>
      ) : (
        <App />
      )}
    </React.StrictMode>,
  );
}
